import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { routesKeyedById } from '../config/constants';
import { getCurrentRoute } from '../services/routes';
import client from '../services/Client';

const BASE_TITLE = 'Ynomia';
const TITLE_SEPARATOR = ' | ';

export const useDocumentTitle = () => {
  const location = useLocation();

  const baseRouteTitleMap: Record<string, string> = {
    '/files': 'Files',
    '/login': 'Login',
    '/forgot-password': 'Forgot Password',
    '/404': '404',
    '/500': '500',
  };

  const withBase = (suffix: string) => `${BASE_TITLE}${TITLE_SEPARATOR}${suffix}`;

  useEffect(() => {
    const { pathname } = location;

    let label: string | undefined;
    const baseRouteTitle = baseRouteTitleMap[pathname];
    if (baseRouteTitle) {
      label = baseRouteTitle;
    } else {
      const { name } = getCurrentRoute() || {};
      const features = client?.cache?.current?.bootstrap?.project?.features;

      if (name) {
        const customLabel = features?.[name]?.customLabel;
        const predefinedRoute = routesKeyedById.get(name);
        label = customLabel ?? predefinedRoute?.label;
      }
    }

    document.title = label
      ? withBase(label)
      : BASE_TITLE;
  }, [location.pathname]);
};
